import { Tabs } from 'src/components/molecules/Tabs';
import styled from 'styled-components';

export const GraphPanelContainer = styled.div`
  min-width: 980px;
  padding: 20px;
  border-radius: 12px;
  ${(props) => props.theme.boxShadows.shadowLarge}
  background-color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default;
  }};
  margin-top: 20px;
`;

export const GraphPanelTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DownloadButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 10px;
`;

export const GraphButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 0;
  top: 26px;
  gap: 20px;
`;

export const ChartComponentContainer = styled.div`
  position: relative;
  margin-bottom: -20px;
`;

export const IntroComponentContainer = styled.div`
  position: relative;
`;

export const StyledTabs = styled(Tabs)`
  background: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default;
  }};
  padding: 20px 0 0 0;
`;
